import { Button, IconChip } from '@app/core';
import { createUseStyles } from 'react-jss';
import { Colors, Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  text: {
    ...theme.fonts.caption,
    color: theme.colors.inkSecondary,
  },
  line: {
    display: 'flex',
    gap: theme.marginBase,
    marginBottom: theme.marginBase * 2,
    marginTop: theme.marginBase,
    whiteSpace: 'pre-line',
  },
  icon: {
    height: 'fit-content',
  },
  button: {
    minHeight: 0,
    minWidth: 0,
    '&:hover:not(:disabled)': {
      backgroundColor: 'transparent',
    },
    '&:active:not(:disabled)': {
      backgroundColor: 'transparent',
    },
    '&:focus:not(:disabled)': {
      backgroundColor: 'transparent',
    },
  },
  buttonContent: {
    padding: 0,
  },
}));

interface Props {
  color: Colors;
  icon: string;
  message: string;
  buttonColor?: Colors;
  buttonText?: string;
  onClick?: () => any;
  withNextArrow?: boolean;
}

export const SessionNotification = ({
  icon,
  color,
  message,
  buttonColor,
  buttonText,
  onClick,
  withNextArrow,
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.line}>
      <IconChip className={classes.icon} color={color} icon={icon} />
      <div>
        <div className={classes.text}>{message}</div>
        {!!buttonText && !!onClick && (
          <Button
            color={buttonColor || color}
            variant="transparent"
            className={classes.button}
            contentClassName={classes.buttonContent}
            text={buttonText}
            onClick={onClick}
            withNextArrow={withNextArrow}
          />
        )}
      </div>
    </div>
  );
};
